import NewLoad from './NewLoad';

const UnifiedLoad = () => {
  return <NewLoad />;
};

export default UnifiedLoad;
